import React from 'react'
import "./Footer.module.css";
import "../../App.css"
function Footer() {
    return (
        <div className='maple-flex-xy-center maple-footer'>
            <h1 className='txt-lg'>Made with love by <span><a href='https://twitter.com/KrishanuDutta_' target="_blank">KrishanuDutta</a></span></h1>
        </div>
    )
}
export default Footer;